"use client";

import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import {
  useSettingPersistQuickAddOnSearchTile,
  useAssignSettingPersistQuickAddOnSearchTile,
} from "@faire/deprecated-retailer-visitor-shared/settings/useSettingPersistQuickAddOnSearchTile";
import { useEffect } from "react";

export const MaybePersistQuickAdd: React.FC<{
  hoverQuickAdd: React.ReactNode;
  nonHoverQuickAdd: React.ReactNode;
  persistQuickAdd: React.ReactNode;
  showOnHover: boolean;
}> = ({ hoverQuickAdd, nonHoverQuickAdd, persistQuickAdd, showOnHover }) => {
  const shouldPersistQuickAdd = useSettingPersistQuickAddOnSearchTile();

  const assignPersistQuickAdd = useAssignSettingPersistQuickAddOnSearchTile();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  useEffect(() => {
    if (isLoggedInRetailer && showOnHover) {
      assignPersistQuickAdd();
    }
  }, [assignPersistQuickAdd, isLoggedInRetailer, showOnHover]);

  if (showOnHover && shouldPersistQuickAdd) {
    return persistQuickAdd;
  } else if (showOnHover) {
    return hoverQuickAdd;
  } else {
    return nonHoverQuickAdd;
  }
};
